<template>
  <form :class="classes()" slot="name" @submit.prevent="handleSubmit">
    <div :class="`${el}__inputRow`">
      <BaseInput
        label="E-Mail"
        name="email"
        :type="$matchMedia.l ? 'text' : 'email'"
        v-model.trim="formFields.email.value"
        :error="formFields.email.error"
        @input="clearError(formFields.email)"
        clearable
      />
    </div>
    <div :class="`${el}__buttonRow`">
      <Button :label="$t('auth.forgotPassword.form.button')" :loading="loading" submit />
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import BaseInput from '@/objects/Forms/BaseInput';
import Button from '@/objects/Button';
import { validateForm } from '@/helpers/formValidation';
import { emailPattern } from '@/helpers/patterns';
import { ROUTE_API_FORGET_PASSWORD } from '@/constants/apiRoutes';

export default {
  name: 'ForgotPasswordForm',
  props: {},
  components: {
    BaseInput,
    Button,
  },
  data() {
    return {
      el: 'c-forgotPasswordForm',
      loading: false,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
      formFields: {
        email: {
          value: '',
          error: null,
          required: this.$t('auth.register.form.error.email.required'),
          pattern: {
            value: emailPattern,
            message: this.$t('auth.register.form.error.email.formatted'),
          },
        },
      },
    };
  },
  methods: {
    clearError(field) {
      field.error = null;
    },
    handleSubmit(e) {
      const { isValid } = validateForm(e.target.elements, this.formFields);
      if (isValid) {
        this.sendMail();
      }
    },
    sendMail() {
      this.loading = true;

      const { email } = this.formFields;
      const formData = new FormData();
      const user = {
        username: email,
      };

      Object.keys(user).map((name) => {
        formData.append(`user[${name}]`, user[name].value);
      });

      Vue.axios
        .post(ROUTE_API_FORGET_PASSWORD, formData)
        .then((response) => {
          const { status } = response;
          if (status === 200) {
            this.$emit('sent');
          }
          this.loading = false;
        })
        .catch((err) => {
          const {
            data: { errors },
            status,
          } = err.response;

          // status 401 = user_blocked - be triggers event 'password_forget' anyway - so $emit('sent') is correct
          if (status === 401) {
            this.$emit('sent');
          }

          if (status === 422) {
            Object.keys(errors).map((error) => {
              const type = errors[error][0];
              this.formFields['email'].error = this.$t(`auth.register.form.error.email.${type}`);
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>
